export const HUB_MODULE_NAV_ITEM_GAP_PX = 8;
export const HUB_MODULE_NAV_MORE_BUTTON_RESERVE_PX = 44;
export const HUB_MODULE_NAV_MORE_LABEL_RESERVE_PX = 92;

export function computeHubModuleNavVisibleCount(
  widths: number[],
  containerWidth: number,
  options?: { alwaysShowMore?: boolean; moreButtonReservePx?: number },
): number {
  if (widths.length === 0 || containerWidth <= 0) {
    return widths.length;
  }

  const moreReserve = options?.moreButtonReservePx ?? HUB_MODULE_NAV_MORE_BUTTON_RESERVE_PX;
  const alwaysShowMore = options?.alwaysShowMore === true;

  let sum = 0;
  for (let index = 0; index < widths.length; index += 1) {
    sum += widths[index] + (index > 0 ? HUB_MODULE_NAV_ITEM_GAP_PX : 0);
  }
  if (!alwaysShowMore && sum <= containerWidth) {
    return widths.length;
  }

  const budget = containerWidth - moreReserve - HUB_MODULE_NAV_ITEM_GAP_PX;
  sum = 0;
  for (let index = 0; index < widths.length; index += 1) {
    const next = sum + widths[index] + (index > 0 ? HUB_MODULE_NAV_ITEM_GAP_PX : 0);
    if (next > budget) {
      return Math.max(0, index);
    }
    sum = next;
  }
  return widths.length;
}
